import {RqInputDocumentAdditionalInformation} from "./RqInputDocumentAdditionalInformation";

export class RqInputDocument {
    documentNumber: string | undefined
    type: string | undefined
    additionalInformation: RqInputDocumentAdditionalInformation[]

    constructor(
        documentNumber: string | undefined,
        type: string | undefined,
        additionalInformation: RqInputDocumentAdditionalInformation[]
        ) {
        this.documentNumber = documentNumber;
        this.type = type;
        this.additionalInformation = additionalInformation
    }

    static empty(): RqInputDocument {
        return new RqInputDocument(undefined, undefined, [])
    }
}